<template>
  <div>
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        นโยบายคุกกี้ 
        <small></small>
      </h1>
      <ol class="breadcrumb">
        <li>
          <i class="fa fa-dashboard"></i> นโยบายคุกกี้
        </li>
      </ol>
    </section>
    <section class="content">
      <transition name="page" mode="out-in">
        <div class="row">
          <div class="col-xs-12" style="height:660px;">
            <div class="box box-primary container">
              <div class="box-header">
                <div id = "content_th"></div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </section>
  </div>
</template>

<style>
.consent-content {
    padding-left: 100px;
    padding-right: 100px;
    margin-bottom: 200px;
}
</style>
<script>
import { mapState, mapActions } from 'vuex';
export default {
  data(){
    return{
        data: {
            content_th: ''
        }
    }
  },
  created() {
    // this.$store.dispatch('TermsAndConditionStore/getTermsAndCondition')
    this.$store.dispatch('CookiePrivacyStore/getCookie')
  },
  computed: {
    ...mapState({
      content_th : store => store.CookiePrivacyStore.content_th,
      content_en : store => store.CookiePrivacyStore.content_en
    })
  },
  mounted() {
    this.data.content_th = this.content_th
    this.data.content_en = this.content_en
    document.getElementById("content_th").innerHTML = this.content_th
  },
  watch: {
    content_th : {
      handler : function(reload) {
        this.data.content_th = reload
        document.getElementById("content_th").innerHTML = reload
      }
    },
    content_en : {
      handler : function(reload) {
        this.data.content_en = reload
      }
    }
  },
}
</script>



